import { render } from "./Upload.vue?vue&type=template&id=99046e80&bindings={\"isValid\":\"data\",\"isLoading\":\"data\",\"isEsignatureRequested\":\"data\",\"isEsignRequired\":\"data\",\"missingDocuments\":\"data\",\"uploadedFiles\":\"data\",\"onSubmit\":\"options\",\"onSelect\":\"options\",\"onBeforeUpload\":\"options\",\"onUpload\":\"options\",\"onRemove\":\"options\",\"validate\":\"options\",\"stepName\":\"options\",\"isMissingDocumentRequest\":\"options\"}"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script